export default [
  {
    path: '/report/:key?',
    name: 'ReportList',
    component: () => import(/*webpackChunkName:'treasury'*/ '@/views/report/ReportList.vue'),
    meta: {},
  },
];
